import * as React from 'react';

import { humanizeLearningTime } from 'js/utils/DateTimeUtils';

import { SvgClock } from '@coursera/coursera-ui/svg';

import _t from 'i18n!nls/degree-home';

import 'css!./__styl__/EstimatedTimeDisplay';

type Props = {
  timeCommitment?: number;
};

class EstimatedTimeDisplay extends React.Component<Props> {
  render() {
    const { timeCommitment } = this.props;
    if (!timeCommitment) {
      return null;
    }

    return (
      <div className="rc-EstimatedTimeDisplay horizontal-box align-items-vertical-center">
        <div className="horizontal-box align-items-vertical-center color-secondary-text">
          <SvgClock stroke="#757575" size={12} />
          <div className="estimated-time">
            {_t('Estimated total time')}: {humanizeLearningTime(timeCommitment)}
          </div>
        </div>
      </div>
    );
  }
}

export default EstimatedTimeDisplay;
